const templates = [
    {
        'id': 0,
        'template': 'When {{subspace}}, there are {{parameter}} categories of {{groupby}}s, including {{no.1}}, {{no.2}}, {{no.3}}.',
    },
    {
        'id': 1,
        'template': 'When {{subspace}}, the data are grouped into {{parameter}} {{groupby}}s, including {{no.1}}, {{no.2}}, {{no.3}}.',
    },
    {
        'id': 2,
        'template': 'When {{subspace}}, the data include {{parameter}} groups of {{groupby}}s, including {{no.1}}, {{no.2}}, {{no.3}}.',
    },
]

export default templates;